<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
    <g transform="translate(-21 -132)">
      <line class="a" x2="18" transform="translate(22 139)"/>
      <line class="a" x2="18" transform="translate(22 133)"/>
      <line class="a" x2="18" transform="translate(22 145)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HamburgerIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
